import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AttributeTopBrandsProps {
  scores: Record<string, Record<string, any>>;
  attributes: string[];
  findCompetitorUrl: (brand: string) => string;
  getFavicon: (url: string) => string;
}
const AttributeTopBrands: React.FC<AttributeTopBrandsProps> = ({
  scores,
  attributes,
  findCompetitorUrl,
  getFavicon
}) => {
  const [selectedAttribute, setSelectedAttribute] = useState<string>(attributes.length > 0 ? attributes[0] : '');
  const [showAllBrands, setShowAllBrands] = useState(false);
  // Get score value safely (handles both old and new format)
  const getScore = (brand: string, attribute: string) => {
    const value = scores[brand][attribute];
    if (typeof value === 'number') {
      return value;
    } else if (typeof value === 'object' && value !== null && 'score' in value) {
      return value.score;
    }
    return 0;
  };
  // Get top brands for the selected attribute
  const getTopBrands = (attribute: string, limit: number) => {
    const brandScores = Object.entries(scores).map(([brand, brandScores]) => ({
      brand,
      score: getScore(brand, attribute)
    })).sort((a, b) => b.score - a.score).slice(0, limit);
    return brandScores;
  };
  const topBrands = selectedAttribute ? getTopBrands(selectedAttribute, showAllBrands ? 10 : 5) : [];
  return <div className="w-full" data-id="element-729" data-mp="22d860z8fimrn">
      <div className="mb-6" data-id="element-730" data-mp="22e036ehocsk1">
        <label htmlFor="attribute-select" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-731" data-mp="27aqigzlnnk4e">
          Selecione um atributo
        </label>
        <div className="relative inline-block w-full max-w-xs" data-id="element-732" data-mp="1sk9hfhcxmw81">
          <select id="attribute-select" value={selectedAttribute} onChange={e => setSelectedAttribute(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-[#1649ff] focus:border-[#1649ff] sm:text-sm rounded-md appearance-none shadow-sm text-gray-900" data-id="element-733" data-mp="1xjm4o37pu5b5">
            {attributes.map(attribute => <option key={attribute} value={attribute} data-id="element-734" data-mp="2uwaqik6fbjh9">
                {attribute}
              </option>)}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-735" data-mp="2lygsn4t0ghrz">
            <ChevronDown className="h-4 w-4 text-gray-400" data-id="element-736" data-mp="2gyvtat9xi7eq" />
          </div>
        </div>
      </div>
      <div className="space-y-4" data-id="element-737" data-mp="2c7m57x413c4y">
        {topBrands.map(({
        brand,
        score
      }, index) => <div key={brand} className="flex flex-col" data-id="element-738" data-mp="2789irdh2k72w" data-mpi={index}>
            <div className="flex items-center mb-1" data-id="element-739" data-mp="2792lm3cwqcfr">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full mr-2 text-xs font-bold text-gray-900" data-id="element-740" data-mp="22ahi9v2czcn3">
                {index + 1}
              </div>
              <img src={getFavicon(findCompetitorUrl(brand))} alt={`${brand} logo`} className="w-5 h-5 mr-2" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://www.google.com/s2/favicons?domain=example.com&sz=128';
          }} data-id="element-741" data-mp="1t8rpakstw5n7" />
              <span className="text-sm font-medium text-gray-900" data-id="element-742" data-mp="mr0dry7vzjn5">{brand}</span>
              <span className="ml-auto text-sm font-bold text-gray-900" data-id="element-743" data-mp="3m65epdx6emp7">
                {score}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-744" data-mp="3q8ihbtgmm4hr">
              <div className="h-2.5 rounded-full bg-[#1649ff]" style={{
            width: `${score}%`
          }} data-id="element-745" data-mp="3v6tr646x8ezz"></div>
            </div>
          </div>)}
        {topBrands.length === 0 && <div className="text-center py-4 text-gray-500" data-id="element-746" data-mp="32ftp3ys5hlay">
            Não há dados disponíveis para este atributo.
          </div>}
      </div>
      {/* Expand/Collapse button */}
      {Object.keys(scores).length > 5 && <button onClick={() => setShowAllBrands(!showAllBrands)} className="mt-4 text-sm text-gray-500 hover:text-gray-700 flex items-center mx-auto" data-id="element-747" data-mp="18zfkf9vo6yhg">
          {showAllBrands ? <>
              <ChevronUp size={16} className="mr-1" data-id="element-748" data-mp="1hysti1fvtl1n" />
              Mostrar menos
            </> : <>
              <ChevronDown size={16} className="mr-1" data-id="element-749" data-mp="1wmx6qpw614d1" />
              Mostrar mais
            </>}
        </button>}
    </div>;
};
export default AttributeTopBrands;